(() => {

  const activateSwatches = () => {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(card => {
      if (card.classList.contains('product-card--swatches-active')) return;
      card.classList.add('product-card--swatches-active');
      const swatches = card.querySelectorAll('.product-card-shape-swatches-wrapper a.unstyled-link, .product-card__image-swatches-wrapper a.unstyled-link');
      swatches.forEach(swatch => {
        swatch.addEventListener('mouseover', () => {
          card.querySelectorAll('.product-card__images-wrapper')?.forEach(image => {
            if (swatch.getAttribute('data-variant-id') == image.getAttribute('data-product-id')) {
              card.querySelector(".product-card__title").textContent = image.getAttribute('data-product-title');
              card.querySelector(".product-card__title").href = image.getAttribute('data-product-url');
              image.classList.remove('hidden');
            } else {
              image.classList.add('hidden');
            }
          })
        });
      });
    });
  }

  setInterval(() => {
    activateSwatches();
  }, 500);
})();